module.exports = __webpack_public_path__ + "img/beginner-intermediate.e949bf65.svg";